import type React from 'react';
import styles from './RightDrawer.module.css';

export interface DrawerContentData {
  title?: string;
  component: React.ReactNode;
}

interface RightDrawerProps {
  isOpen: boolean;
  content: DrawerContentData | null;
  onClose: () => void;
}

export const RightDrawer: React.FC<RightDrawerProps> = ({ isOpen, content, onClose }) => {
  if (!content) return null;

  return (
    <div className={styles.drawerContainer} data-open={isOpen ? 'true' : 'false'}>
      <div className={styles.drawerHeader}>
        <h3 className={styles.drawerTitle}>{content.title || 'Details'}</h3>
        <button className={styles.closeButton} onClick={onClose} type="button" aria-label="Close drawer">
          ×
        </button>
      </div>
      <div className={styles.drawerBody}>{content.component}</div>
    </div>
  );
};
